import { Link } from "~/ui-library";

export type NewsletterPrivacyPolicyProps = {
  linkClassName: string;
  /** A string which must adhere to the text "By taking action,"
   *
   * This allows us to give contextual information
   *
   * @example
   * <NewsletterPrivacyPolicy
   *   preamble="By clicking the button below,"
   * />
   *
   * <NewsletterPrivacyPolicy
   *    preamble='By clicking the "sign up" button,'
   * />
   */
  preamble: `By ${string},`;
};

export const NewsletterPrivacyPolicy: React.FC<
  NewsletterPrivacyPolicyProps
> = ({ linkClassName, preamble }) => (
  <>
    {preamble} you consent to Morning Consult processing your information
    pursuant to our{" "}
    <a
      className={linkClassName}
      href="https://morningconsult.com/privacy-policy/"
      tabIndex={0}
    >
      Privacy Policy
    </a>{" "}
    and you further acknowledge that you understand and agree to the{" "}
    <a
      className={linkClassName}
      href="https://morningconsult.com/privacy-policy/"
      tabIndex={0}
    >
      Privacy Policy
    </a>{" "}
    and the{" "}
    <Link
      className={linkClassName}
      href="/terms-and-conditions-of-use"
      tabIndex={0}
    >
      Morning Consult Pro Terms and Conditions of Use
    </Link>
    .
  </>
);
